export enum EntityHierarchyTypes {
    Standalone = 1,
    Cloned = 2,
    Mastered = 3,
}
